import './Navbar.css';
import { LuMenu } from "react-icons/lu";
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar(){
    const [isNavExpanded, setIsNavExpanded] = useState(false)
    const synonyms = [ "nonsense", "balderdash", "gibberish", "claptrap", "rubbish", "hogwash", "baloney", "gobbledygook", "folly", "babble", "madness", "mumbo jumbo", "silliness"];
    const taglineWord = synonyms[Math.floor(Math.random() * synonyms.length)];

    return(
        <nav className={isNavExpanded ? "nav expanded" : "nav"}>
            <div className='navHeader'>
                <h1 className='navTitle'><Link to='/'>classifieds.lol</Link></h1>
                <h2 className='navTagline'>worldwide <p id='taglineWord'>{taglineWord}</p> for those who need it</h2>
            </div>
            <ul className={isNavExpanded ? "navList expanded" : "navList"}>
                <li>
                    <Link className='navItem' to='/posts'>
                        all posts
                    </Link>
                </li>
                <li>
                    <Link className='navItem' to='/categories'>
                        browse by category
                    </Link>
                </li>
                <li>
                    <Link className='navItem' to='/contributors'>
                        contributors
                    </Link>
                </li>
                <li>
                    <Link className='navItem' to='/about'>
                        about
                    </Link>
                </li>
            </ul>
            <button className="menuButton" onClick={() => {setIsNavExpanded(!isNavExpanded);}} >
                <LuMenu className="menuIcon" />
            </button>
        </nav>
    );
}